export function textBenefitsSlider() {
    const $window = $(window);
    const parent = $(".text-benefits.slider-on-mobile");
    let sliderNav = "";
    let $current = "";
    let $total = "";

    function mobileSlider() {
        parent.each(function () {
            let $this = $(this);
            sliderNav = $this.next(".text-benefits-slider-nav");
            $current = sliderNav.find('.current');
            $total = sliderNav.find('.total');
            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        dots: false,
                        arrows: true,
                        appendArrows: sliderNav,
                        infinite: false,
                        speed: 700,
                        cssEase: 'ease',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                    }).on('init reInit afterChange', function (event, slick, currentSlide) {
                        let i = (currentSlide ? currentSlide : 0) + 1;
                        $current.text(i);
                        $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
                    });
                    $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
                    $current.text("1");
                }
            }
        });
    }

    $window.on("load scroll resize", function () {
        mobileSlider();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/textBenefitsSlider.js